import { render, staticRenderFns } from "./InitialsAvatar.vue?vue&type=template&id=e0a6919a&"
import script from "./InitialsAvatar.vue?vue&type=script&lang=js&"
export * from "./InitialsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0a6919a')) {
      api.createRecord('e0a6919a', component.options)
    } else {
      api.reload('e0a6919a', component.options)
    }
    module.hot.accept("./InitialsAvatar.vue?vue&type=template&id=e0a6919a&", function () {
      api.rerender('e0a6919a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/InitialsAvatar.vue"
export default component.exports